import React from 'react'
import { hooks } from '@front/volcanion'

const getOptionType = (model_name) => {
  if (model_name === 'useroption') return 'driver'
  if (model_name === 'vehicleoption') return 'vehicle'
  return null
}

const withContainer = Component => props => {
  const [model_name] = hooks.useFormState('model_name')
  const optionType = getOptionType(model_name)

  const mergedProps = {
    optionType
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
